import React, { useState } from 'react';
import '../style.css';

function DeleteConfirm({ openModel, onclosemodel, onConfirm, taskTitle }) {
    const [confirmText, setConfirmText] = useState('');
    const [error, setError] = useState(false);

    const handleDelete = () => {
        onConfirm();
        onclosemodel();
    };

    const handleInputChange = (e) => {
        setConfirmText(e.target.value);
        if (error) setError(false);
    };

    const isConfirmValid = confirmText.toLowerCase() === 'confirm';

    if (!openModel) return null;

    return (
        <div className="modal-zz-confirm text-left">
            <div
                className="bg-white rounded"
                style={{
                    position: "relative",
                    maxWidth: '450px',
                    margin: '100px auto',
                    padding: '30px'
                }}
            >
                <span
                    className='crossison'
                    onClick={onclosemodel}
                    style={{
                        position: 'absolute',
                        right: '15px',
                        top: '15px',
                        cursor: 'pointer',
                        fontSize: '20px',
                        color: '#6C757D'
                    }}
                >
                    ✕
                </span>

                <h2
                    className='text-black text-left'
                    style={{
                        fontSize: '20px',
                        fontWeight: '700',
                        marginBottom: '15px',
                        marginTop: 0
                    }}
                >
                    Delete Task
                </h2>

                <p
                    style={{
                        fontSize: '14px',
                        color: '#6C757D',
                        marginBottom: '20px',
                        lineHeight: '1.5'
                    }}
                >
                    Once deleted your Task can not be restored! please type <strong>Confirm</strong> to delete this Task.
                </p>

                <input
                    type="text"
                    className='w-100 form-control-agust input_od_addPrompt'
                    style={{
                        padding: '12px',
                        borderRadius: '8px',
                        border: error ? '1px solid #dc3545' : '1px solid #d2d6da',
                        marginBottom: '5px'
                    }}
                    value={confirmText}
                    onChange={handleInputChange}
                    placeholder="Type Confirm"
                />

                {error && (
                    <small style={{ color: '#dc3545', fontSize: '12px', display: 'block', marginBottom: '15px' }}>
                        Please type Confirm to proceed
                    </small>
                )}

                <div className='w-100' style={{ marginTop: '20px' }}>
                    <button
                        onClick={handleDelete}
                        disabled={!isConfirmValid}
                        style={{
                            padding: '12px',
                            fontSize: '16px',
                            fontWeight: '600',
                            background: isConfirmValid ? '#C00F0C' : '#FCB3AD',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            width: '100%',
                            cursor: isConfirmValid ? 'pointer' : 'not-allowed',
                            opacity: isConfirmValid ? 1 : 0.6,
                            transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                            if (isConfirmValid) e.target.style.opacity = '0.9';
                        }}
                        onMouseLeave={(e) => {
                            if (isConfirmValid) e.target.style.opacity = '1';
                        }}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}

export default DeleteConfirm;
